import * as React from 'react'

import { Button } from './button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog'

/**
 * v2 · Popups are centred on every viewport — the mobile bottom sheet
 * is gone. One shell: title block, full-bleed hairline, content, the
 * white block CTA, then the quiet cancel underneath.
 */
export interface ResponsiveDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: React.ReactNode
  description?: React.ReactNode
  /** Primary action — the one thing this popup is asking for. */
  action?: { label: React.ReactNode; onClick?: () => void; processing?: boolean }
  /** Secondary action — the quiet text button below the CTA. */
  cancel?: { label: React.ReactNode; onClick?: () => void }
  children?: React.ReactNode
}

export function ResponsiveDialog({
  open,
  onOpenChange,
  title,
  description,
  action,
  cancel,
  children,
}: ResponsiveDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <DialogBody>
          {children}
          {(action || cancel) && (
            <DialogFooter>
              {action && (
                <Button
                  variant="primary"
                  size="block"
                  processing={action.processing}
                  onClick={action.onClick}
                >
                  {action.label}
                </Button>
              )}
              {cancel && (
                <Button variant="inline" size="default" className="h-11" onClick={cancel.onClick}>
                  {cancel.label}
                </Button>
              )}
            </DialogFooter>
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
